// import { getVelocityByV0ADeltaT, getDistanceByS0V0DeltaTA } from '../helpers/kinematics';

// Объект с равноускоренным движением
export default class AbstractMovingObject {
    #startDistance;

    #velocity;
    #acceleration;
    #distance = 0;
    #startVelocity;

    addDistance(deltaDistance) {
        this.#distance += deltaDistance;
        // console.log(this.#distance);
    }

    get distance() {
        return this.#distance;
    }

    get startDistance() {
        return this.#startDistance;
    }

    get acceleration() {
        return this.#acceleration;
    }

    get startVelocity() {
        return this.#startVelocity;
    }

    // #acceleration;

    // get acceleration() {
    //     return this.#acceleration;
    // }

    // // пройденное время [c]
    // deltaT = 0;

    // currentVelocity;
    // // скорость [м/с]
    // get velocity() {
    //     if (this.currentVelocity !== undefined) return this.currentVelocity;

    //     return getVelocityByV0ADeltaT(this.#startVelocity, this.#acceleration, this.deltaT);
    // }

    // set velocity(value) {
    //     this.currentVelocity = value;
    // }

    // // пройденное расстояние [м]
    // // TODO переделать расчет пройденного расстояния, прибавлять каждый тик пройденное расстояние за тик к уже пройденному расстоянию
    // get distance() {
    //     return getDistanceByS0V0DeltaTA(this.#startDistance, this.#startVelocity, this.deltaT, this.#acceleration);
    // }

    setStartKinematicsParams({ startDistance = 0, startVelocity = 0, acceleration = 0 }) {
        this.#distance = startDistance;
        this.#velocity = startVelocity;
        this.#acceleration = acceleration;
        this.#startDistance = startDistance;
        this.#startVelocity = startVelocity;
    }

    stopMoving() {
        this.velocity = 0;
    }
}
